<template>
  <div class="row">
    <div class="modal fade" id="modal-form-cambio-tepconductor">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Cambiar Conductor</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div
                class="col-md-12"
                v-if="this.dataTurno && this.dataTurno.conductor2"
              >
                <label>Conductor a cambiar</label>
                <table
                  class="
                    table table-bordered table-striped table-hover table-sm
                    text-nowrap
                  "
                >
                  <tbody>
                    <tr>
                      <td class="text-center">1</td>
                      <td class="text-center">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="conductor"
                            @click="getForm(1)"
                          />
                        </div>
                      </td>
                      <td>{{ this.dataTurno.conductor.numero_documento }}</td>
                      <td>
                        {{ this.dataTurno.conductor.nombres }}
                        {{ this.dataTurno.conductor.apellidos }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-center">2</td>
                      <td class="text-center">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="conductor"
                            @click="getForm(2)"
                          />
                        </div>
                      </td>
                      <td>{{ this.dataTurno.conductor2.numero_documento }}</td>
                      <td>
                        {{ this.dataTurno.conductor2.nombres }}
                        {{ this.dataTurno.conductor2.apellidos }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="form-group col-md-12">
                <label>Conductor Nuevo</label>
                <v-select
                  :class="[
                    $v.form.conductor.$invalid ? 'is-invalid' : 'is-valid',
                    $store.getters.getDarkMode ? 'dark-vselect' : '',
                  ]"
                  v-model="form.conductor"
                  placeholder="Conductor"
                  label="nConductor"
                  class="form-control form-control-sm p-0"
                  :options="listasForms.conductores"
                  :filterable="false"
                  @search="buscarConductores"
                  @input="validarDocumentos()"
                ></v-select>
              </div>
              <div class="form-group col-md-12">
                <label>Justificación</label>
                <div>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="form.justificacion"
                    :class="
                      $v.form.justificacion.$invalid ? 'is-invalid' : 'is-valid'
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              @click="save()"
              v-if="
                $store.getters.can('tep.turnos.cambiarConductor') &&
                  !$v.form.$invalid
              "
            >
              Guardar
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";

export default {
  name: "TepTurnoCambiarConductor",
  components: {
    vSelect,
  },
  data() {
    return {
      dataTurno: null,
      turno_id: null,
      conductor_id: null,
      conductor2_id: null,
      form: {
        turno_id: null,
        num_conductor: null,
        conductor: null,
        justificacion: null,
      },
      listasForms: {
        conductores: [],
      },
    };
  },
  validations() {
    return {
      form: {
        justificacion: {
          required,
        },
        num_conductor: {
          required,
        },
        conductor: {
          required,
        },
      },
    };
  },
  methods: {
    llenar_modal(item) {
      this.dataTurno = item;
      this.resetForm();

      if (!this.dataTurno.conductor2) {
        this.form.num_conductor = 1;
        this.form.conductor_ant = {
          id: this.dataTurno.conductor_id,
          documento: this.dataTurno.conductor.numero_documento,
          nombre: `${this.dataTurno.conductor.nombres} ${this.dataTurno.conductor.apellidos}`,
        };
      }
    },

    resetForm() {
      this.form = {
        turno_id: this.dataTurno.id,
        det_postulacion_id: this.dataTurno.det_postulacion_id,
        num_conductor: null,
        conductor: null,
        justificacion: null,
      };
    },

    getForm(num_conductor = 1) {
      let conductor = this.form.conductor;
      let justificacion = this.form.justificacion;
      this.form = {
        turno_id: this.dataTurno.id,
        det_postulacion_id: this.dataTurno.det_postulacion_id,
        num_conductor,
        conductor,
        justificacion,
      };

      // Se valida cual conductor se va a cambiar
      if (num_conductor == 1) {
        this.form.conductor_ant = {
          id: this.dataTurno.conductor_id,
          documento: this.dataTurno.conductor.numero_documento,
          nombre: `${this.dataTurno.conductor.nombres} ${this.dataTurno.conductor.apellidos}`,
        };
      } else {
        this.form.conductor_ant = {
          id: this.dataTurno.conductor2_id,
          documento: this.dataTurno.conductor2.numero_documento,
          nombre: `${this.dataTurno.conductor2.nombres} ${this.dataTurno.conductor2.apellidos}`,
        };
      }
    },

    buscarConductores(search, loading) {
      this.listasForms.conductores = [];
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/tep/turno/listaConductores?search=" + search;
        axios
          .get(url)
          .then(function(response) {
            me.listasForms.conductores = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    async validarDocumentos() {
      this.$parent.cargando = true;
      try {
        const response = await axios.get("/api/tep/turno/validarDocumentos", {
          params: {
            id: this.form.conductor.id,
            entidad: "Conductor",
          },
        });
        if (response.data.error) {
          this.form.conductor = null;
          this.$swal({
            icon: "error",
            title: response.data.error.msg,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Ocurrio un error" + error,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } finally {
        this.$parent.cargando = false;
      }
    },

    save() {
      this.$swal({
        title: "Esta seguro de cambiar este conductor?",
        text: "No podra revertir esta acción",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Realizar el cambio!",
      }).then((result) => {
        if (result.value) {
          this.$parent.cargando = true;
          axios
            .put("/api/tep/turno/cambiarConductor", {
              data: this.form,
            })
            .then((response) => {
              this.$refs.closeModal1.click();
              this.$parent.getIndex();
              this.form = {};
              this.$swal({
                icon: "success",
                title: response.data.mensaje,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Ocurrio un error" + error,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            })
            .finally(() => {
              this.$parent.cargando = false;
            });
        }
      });
    },
  },
};
</script>
